import { Text } from 'blaze-ui/Text/Text'
import UserProfileAdd2 from 'blaze-ui/icons/20/UserProfileAdd2'
import cx from 'classnames'
import Styles from './IntegrationSelector.module.scss'

interface AddNewAccountRowProps {
  showPaywallHint?: boolean
  onClick?: () => void
  testId?: string
}

export const AddNewAccountRow: React.FC<AddNewAccountRowProps> = ({ showPaywallHint = false, onClick, testId }) => {
  const content = (
    <>
      <UserProfileAdd2 size={20} color="var(--dark-80)" />
      <div>
        <Text variant="placeholder" color="var(--dark-80)">
          Connect Extra Account
        </Text>
        {showPaywallHint && (
          <Text variant="metadata" color="var(--dark-40)">
            $10 per month
          </Text>
        )}
      </div>
    </>
  )

  if (onClick) {
    return (
      <button
        type="button"
        className={cx(Styles.addNewAccountItem, Styles.addNewAccountTrigger)}
        onClick={onClick}
        data-testid={testId}
      >
        {content}
      </button>
    )
  }

  return <div className={Styles.addNewAccountItem}>{content}</div>
}
